import { Document, Page, Text, View, Image, StyleSheet, Font } from '@react-pdf/renderer';
import React from 'react';
import Home from "../../../Assets/Images/Leadpage2.png";

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 21,
    paddingVertical: 30,
    backgroundColor: '#FFFFFF',
    justifyContent: "space-between",
    height: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #00577D',
    paddingBottom: 5,
    marginBottom: 2,
    marginTop: '-15px'
  },
  headerleft: {

  },
  titlemain: {
    fontSize: 12,
    fontWeight: 700,
    color: '#76A3BE',
  },
  title: {
    fontSize: 11,
    fontWeight: 200,
    color: '#76A3BE',
  },
  rightsection: {
    alignItems: 'flex-end',
    flexDirection: 'column',
    flex: 1,
  },
  rightText: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
  rightTextsybtext: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
  section: {
    marginVertical: 10,
  },
  container: {
    flexDirection: 'row',
    marginTop: 20,
    fontFamily: 'Lato',
  },
  containerrightsection: {
    marginLeft: 25,
    maxWidth: 315
  },
  image: {
    width: 193,
    height: 193,
    alignSelf: 'center',
  },
  headertext: {
    fontSize: 18,
    fontWeight: 700,
    color: '#426B88',
    marginBottom: 60,
    marginTop: 8
  },
  contentTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
  },
  paragraph: {
    fontSize: 12,
    textAlign: 'justify',
    fontWeight: 400,
    color: '#245775',
    marginBottom: 5,
    fontFamily: 'Lato',
  },
  paragraphtopspace: {
    fontSize: 12,
    textAlign: 'justify',
    fontWeight: 400,
    color: '#245775',
    marginBottom: 5,
    fontFamily: 'Lato',
    marginTop: 12
  },
  collaborativeHighlight: {
    color: '#C4391D',
    fontSize: 12,
    fontWeight: 700,
  },

  highlightVisionary: {
    color: '#00577D',
    fontSize: 12,
    fontWeight: 700,
  },
  highlightPerformance: {
    color: '#C99212',
    fontSize: 12,
    fontWeight: 700,
  },
  highlightStrategic: {
    color: '#667F96',
    fontSize: 12,
    fontWeight: 700,
  },
  footer: {
    width: 540,
    borderTop: '1px solid #00577D',
    paddingTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'absolute',
    bottom: 15,
    left: 10,
    right: 21,
  },
  footersection: {
    flexDirection: 'column'
  },
  footerTextheading: {
    fontSize: 10,
    fontWeight: 700,
    fontFamily: 'Lato',
    color: '#76A3BE',
  },
  footerText: {
    fontSize: 8,
    fontFamily: 'Lato',
    fontWeight: 400,
    color: '#76A3BE',
  },
});

const LeadershipPage2 = () => {
  return (
      <View style={styles.page}>
        <View>
          {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerleft}>
            <Text style={styles.titlemain}>QUADRANT FLOW</Text>
            <Text style={styles.title}>Life & Leadership Assssment</Text>
          </View>
          <View style={styles.rightsection}>
            <Text style={styles.rightText}>Rob Murray</Text>
            <Text style={styles.rightTextsybtext}>Atlas Real Estate{"\n"}Oct 18, 2024</Text>
          </View>
        </View>

        {/* Image */}
        <View style={styles.container}>
          <Image src={Home} style={styles.image} />
          <View style={styles.containerrightsection}>
            <Text style={styles.headertext}>THE FOUR LEADERSHIP STYLES</Text>
            <Text style={styles.paragraph}>
              <Text style={styles.collaborativeHighlight}>Collaborative </Text>
              Leaders are driven by their values, passions, and the desire to build meaningful relationships. They use their Heart Quadrant to connect with others, creating purpose and a sense of belonging. With strong emotional intelligence, natural empathy, and the ability to motivate, they lead through relationships and circles of trust, helping people bond and work well together.
            </Text>
          </View>
        </View> 

        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.paragraph}>
            <Text style={styles.highlightVisionary}>Visionary </Text>
            Leaders are driven by what brings meaning, value, and purpose to their team or organization. Using their Soul Quadrant, they offer inspiring visions, creative ideas, iconic branding, and core stories that bring meaning and motivation. They are the visionaries, innovators, and storytellers who provide a fresh perspective and an inspiring purpose to help the organization achieve its mission.
          </Text>

          <Text style={styles.paragraphtopspace}>
            <Text style={styles.highlightStrategic}>Strategic </Text>
            Leaders are motivated by creating strategies and plans that establish common goals, viable structures, and team alignment. They use their Mind Quadrant to build the conceptual frameworks that integrate policies and steward organizational assets. They are the designers, thinkers, and planners who provide the unifying principles and processes that empower people to solve complex problems and function effectively.
          </Text>

          <Text style={styles.paragraphtopspace}>
            <Text style={styles.highlightPerformance}>Performance </Text>
            Leaders are motivated by achievement and getting results. They use their Strength Quadrant to execute on their assigned tasks and fulfill their leadership responsibilities. They are the doers, the managers, and the drivers who have energy to achieve measurable and attainable goals. They have a strong desire to serve people with excellence and accountability.
          </Text>
        </View>
        </View>
        {/* Footer Section */}
        <View style={styles.footer}>
          <View style={styles.footersection}>
            <Text style={styles.footerTextheading}>SELF REPORT</Text>
            <Text style={styles.footerText}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
          </View>
          <Text style={styles.footerTextheading}>PAGE</Text>
        </View>
      </View>
  );
};

export default LeadershipPage2;
